import { ContentService } from '@blk/cwp-ng-framework';
import { DateUtil } from '@ddt-web/generic-utils';
import * as isNil from 'lodash/isNil';

import { Formatter } from './formatter.interface';

export class DateFormatter implements Formatter {
	constructor(public readonly pattern?: string, private defaultValue?: string) { }
	public format(value: any, contentSvc?: ContentService): string {
		if (this.defaultValue && isNil(value)) {
			return this.defaultValue;
		} else {
			if (!(typeof value === 'string' || typeof value === 'number')) {
				return value;
			}
			if (typeof value === 'string' && value?.includes('T')) {
				value = value.split('T')[0];
			}

			try {
				const date = DateUtil.createDayjsFromDate(value);

				if (date.isValid()) {
					if (this.pattern === DateUtil.MODELS_EU_DATE_FORMAT) {
						return DateUtil.formatDateEU(date);
					} else if (this.pattern === DateUtil.MMMM_YYYY_FORMAT) {
						return DateUtil.formatDateText(date);
					} else if (this.pattern === DateUtil.MODELS_US_DATE_FORMAT) {
						return DateUtil.formatDashesDateUS(date);
					} else {
						if (typeof value === 'string' && value.match(/\d{4}-\d{2}-\d{2}$/)) {
							return DateUtil.formatDashesDate(date);
						} else {
							return DateUtil.formatDate(date);
						}
					}
				} else {
					return String(value);
				}

			} catch (error) {
				console.error(error);
				return value;
			}
		}
	}
}
